import { render, staticRenderFns } from "./IdentityView.vue?vue&type=template&id=5c5dcea7&scoped=true&"
import script from "./IdentityView.vue?vue&type=script&lang=js&"
export * from "./IdentityView.vue?vue&type=script&lang=js&"
import style0 from "./IdentityView.vue?vue&type=style&index=0&id=5c5dcea7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5dcea7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCol,VContainer,VRow})
